export const SIGN_UP_CHANGE_FIELD = 'SIGN_UP_CHANGE_FIELD';
export const SIGN_UP_PAGE_DOWN = 'SIGN_UP_PAGE_DOWN';
export const SIGN_UP_CLEAR_ALL_FIELDS = 'SIGN_UP_CLEAR_ALL_FIELDS';

export const SIGN_UP = 'SIGN_UP';